<template>
  <div>
    <apexchart ref="demoChart" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from "vue"

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

let ru = require("apexcharts/dist/locales/ru.json")

export default {
  name: "ChartBar",
  data() {
    return {
      loading: false,
      options: {
        chart: {
          id: 'vuechart-example',
          locales: [ru],
          defaultLocale: 'ru',
          type: 'bar',
          zoom: {
            enabled: true
          },
          events: {
            mouseMove: (chartContext, options, dataPointIndex) => {
              if (dataPointIndex.seriesIndex < 0 || dataPointIndex.dataPointIndex < 0) return
              // this.$emit('mouseMove', dataPointIndex.config.series[dataPointIndex.seriesIndex].data[dataPointIndex.dataPointIndex])
            }
          },
        },
        yaxis: {
          opposite: true,
          strokeDashArray: 12,
          borderColor: '#c2c2c2',
          fillColor: '#c2c2c2',
        },
        xaxis: {
          type: 'datetime',
          tickPlacement: 'on',
          tickAmount: 8,
          lines: {
            colors: ['#43D3B3', '#545454'],
            opacity: 0.5,
            show: false
          },
          tooltip: {
            enabled: true,
            formatter: undefined,
            offsetY: 0,
            style: {
              fontSize: 50,
              fontFamily: 0,
            },
          },
        },
        markers: {
          size: 5,
          colors: '#fff',
          strokeColors: '#43D3B3',
          strokeWidth: 2,
          strokeOpacity: 0.9,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          shape: "circle",
          radius: 2,
          offsetX: 0,
          offsetY: 0,
          onClick: undefined,
          onDblClick: undefined,
          showNullDataPoints: true,
          hover: {
            size: undefined,
            sizeOffset: 3
          }
        },
        colors: ['#43D3B3', '#545454'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        fill: {
          opacity: 1
        },
        grid: {
          borderColor: '#EAEAEA',
          row: {
            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.1
          },
          column: {
            colors: ['transparent', 'transparent'],
          },

          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: true,
            }
          },
        },
        tooltip: {
          enabled: true,
          // custom: function ({seriesIndex, dataPointIndex}) {
          //   // series, seriesIndex,
          //   return '<div class="arrow_box"> ' + dataPointIndex + ' - ' + ' - ' + seriesIndex + '<span>месяц</span>' + '</div>'
          // },
          enabledOnSeries: undefined,
          shared: true,
          followCursor: false,
          intersect: false,
          inverseOrder: false,
          fillSeriesColor: false,
          style: {
            fontSize: '12px',
            fontFamily: undefined
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
          x: {
            show: false,
            format: 'dd MMM',
            formatter: (seriesName) => {
              return (new Date(seriesName)).toLocaleString('default', {month: 'long'}) + '-'
            },
          },
          y: {
            formatter: (value, {series, dataPointIndex, seriesIndex, w}) => {
              return '<b>' + series[seriesIndex][dataPointIndex] + '</b> - <span style="font-weight: normal;">' +
                  (new Date(w.globals.initialSeries[seriesIndex].data[dataPointIndex].x)).toLocaleString('default', {
                    month: 'long',
                    day: 'numeric'
                  })
                  + '</span>'
            },
            title: {
              formatter: (value) => {
                // dataPointIndex- -line
                // seriesIndex- -line
                // return  '<b>' + series[seriesIndex][dataPointIndex] + ' </b>' + value
                return value + ':'
              }
            },
          },
          z: {
            formatter: undefined,
            title: 'Size: '
          },
          marker: {
            show: true,
          },
          items: {
            display: 'flex',
          },
          fixed: {
            enabled: false,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          },
        }
      },
      title: {
        text: "Fundamental Analysis of Stocks",
        align: "right"
      },
      subtitle: {
        text: "Price Movements",
        align: "right"
      },
      series: [this.chartData]
    }
  },
  props: {
    date: {},
    chartData: {},
  },
  watch: {
    chartData() {
      this.series = [this.chartData]

      // this.$refs.demoChart.resetSeries()
    }
  }

}

</script>

<style lang="scss" scoped>
/deep/ {
  .arrow_box {
    height: 60px;
    background: #303133;
    border-radius: 1px;
    border: 0;
    padding: 5px 10px 20px 10px;

    font-size: 16px;
    color: #fff;

    span {
      display: block;

      font-size: 20px;
      line-height: 20px;
      color: #c1c1c2;

    }
  }

  .apexcharts-tooltip {
    background: #303133;
    border-radius: 1px;
    border: 0;
    padding: 10px;

    //font-size: 16px;
    color: #fff;
  }
}
</style>